var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section", { staticClass: "full__video" }, [
        _c(
          "div",
          {
            staticClass:
              "intro__content intro__content--mobile influencerlp--header"
          },
          [
            _c("img", {
              attrs: {
                id: "productLogo",
                srcset:
                  "https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro@2x.png" +
                  " 2x, " +
                  "https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro.png" +
                  " 1x"
              }
            }),
            _c("h2", [_vm._v("Cinemagraphs made easy. ")]),
            _vm._m(0),
            _c("p", [
              _vm._v(
                "Don’t miss this incredible chance to create imagery that gets noticed!"
              )
            ]),
            _c(
              "div",
              { staticClass: "btn__group btn__group--splash" },
              [
                _c("get-plan", {
                  attrs: {
                    classes: "btn btn--purpleLight btn__splash",
                    coupon: "500PERKS"
                  }
                })
              ],
              1
            )
          ]
        ),
        _c("div", { staticClass: "fluid__video" }, [
          _c(
            "div",
            {
              staticClass:
                "intro__content intro__content--desktop influencerlp--header"
            },
            [
              _c("img", {
                attrs: {
                  id: "productLogo",
                  srcset:
                    "https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro@2x.png" +
                    " 2x, " +
                    "https://cdn.flixel.com/static/static-web/products/mac/cinemagraphpro.png" +
                    " 1x"
                }
              }),
              _c("h2", [_vm._v("Cinemagraphs made easy. ")]),
              _vm._m(1),
              _c("p", [
                _vm._v(
                  "Don’t miss this incredible chance to create imagery that gets noticed!"
                )
              ]),
              _c(
                "div",
                { staticClass: "btn__group btn__group--splash" },
                [
                  _c("get-plan", {
                    attrs: {
                      classes: "btn btn--purpleLight btn__splash",
                      coupon: "500PERKS"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._m(2),
          _vm._m(3)
        ])
      ]),
      _c("brands"),
      _c("section", { staticClass: "influencerlp" }, [
        _vm._m(4),
        _c("div", { staticClass: "product__section" }, [
          _c("div", { staticClass: "product__section--container" }, [
            _c("div", { staticClass: "product__section--content" }, [
              _vm._m(5),
              _c("div", { staticClass: "productItem__desc" }, [
                _c("p", [
                  _vm._v(
                    "Cinemagraphs are the new visual medium that capture attention in ways that still photos no longer can. They’re living photos. And now, creating stunning cinemagraphs is fast and easy with Cinemagraph Pro. Sign up and save 50% on any yearly Flixel plan. Your membership gives you access to the world’s best cinemagraph creation tools and web services."
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "btn__group" },
                  [
                    _c("get-plan", {
                      attrs: {
                        classes: "btn btn--purpleLight btn__splash",
                        coupon: "500PERKS"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("img", {
                attrs: {
                  id: "designaward",
                  srcset:
                    "https://cdn.flixel.com/static/static-web/awards/awardada@2x.png" +
                    " 2x, " +
                    "https://cdn.flixel.com/static/static-web/awards/awardada.png" +
                    " 1x"
                }
              })
            ]),
            _vm._m(6)
          ])
        ])
      ]),
      _vm._m(7),
      _vm._m(8),
      _vm._m(9),
      _vm._m(10),
      _vm._m(11),
      _vm._m(12),
      _c("section", { staticClass: "influencerlp" }, [
        _c("div", { staticClass: "product__callout" }, [
          _c(
            "div",
            { staticClass: "callout--container" },
            [
              _c("h1", [
                _vm._v("Create Stories That Your Brand Partners Will Love")
              ]),
              _c("p", [
                _vm._v(
                  "Your brand partners want to see how you can authentically combine their stories with yours on social media. Show how those stories fit together in a beautiful cinemagraph, and get results that your audience and partners will love."
                )
              ]),
              _c("get-plan", {
                attrs: {
                  classes: "btn btn--purpleLight btn__splash",
                  coupon: "500PERKS"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._m(13),
      _c("section", { staticClass: "flixelPlan__section" }, [
        _c("div", { staticClass: "flixelPlan__container" }, [
          _c("h1", [_vm._v("Get all the apps with the Business plan")]),
          _c("p", [
            _vm._v(
              "A Flixel Business plan gives you access to Cinemagraph Pro for macOS and iOS, Persecond for macOS, plus the world's leading service for hosting and sharing your HD quality cinemagraphs on the web, and social networks. It's your best value."
            )
          ]),
          _c(
            "div",
            { staticClass: "btn__group" },
            [
              _c("get-plan", {
                attrs: {
                  classes: "btn btn--purpleLight btn__splash",
                  coupon: "500PERKS"
                }
              })
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _vm._v("500px artists save 50% on an annual plan with coupon "),
      _c("b", [_vm._v("500PERKS ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _vm._v("500px artists save 50% on an annual plan with coupon "),
      _c("b", [_vm._v("500PERKS ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "video__overlay" }, [
      _c("iframe", {
        attrs: {
          src:
            "https://media.flixel.com/cinemagraph/gx9n8ek7edn2t9jtj30i?hd=true",
          allow: "autoplay"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "credit" }, [
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "https://flixel.com/AndrewPavlidis/"
          }
        },
        [_vm._v("Andrew Pavlidis")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "product__callout" }, [
      _c("div", { staticClass: "callout--container" }, [
        _c("h1", [_vm._v("Create Thumb-Stopping Cinemagraphs for Social")]),
        _c("p", [
          _vm._v(
            "Cinemagraphs are the new visual medium that capture attention in ways that still photos no longer can. They’re living photos. "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "productItem__title" }, [
      _c("img", {
        attrs: {
          srcset:
            "https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon@2x.png" +
            " 2x, " +
            "https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon.png" +
            " 1x"
        }
      }),
      _c("h2", [_vm._v("Cinemagraph Pro "), _c("span", [_vm._v("for macOS")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "product__section--cinemagraph cpCinemagraph" },
      [
        _c("div", { staticClass: "fluid__video" }, [
          _c("iframe", {
            attrs: {
              src:
                "https://media.flixel.com/cinemagraph/0xvngzr9i1zqggsxptzv?hd=false"
            }
          })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "influencerlp" }, [
      _c("div", { staticClass: "product__callout" }, [
        _c("div", { staticClass: "callout--container" }, [
          _c("h1", [_vm._v("Bring Your Stories to Life with Cinemagraphs")]),
          _c("p", [
            _vm._v(
              "Composed like a great photo, but with a subtle hint of repeating video motion, cinemagraphs tell a vivid story that engages audiences. Here’s why influencers around the world are using cinemagraphs as a part of their content strategy."
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      {
        staticClass:
          "product__section product__section--carousel product__section--carouselBlack"
      },
      [
        _c(
          "div",
          { staticClass: "carousel__item fluid__video carousel__item--wide" },
          [
            _c("iframe", {
              attrs: {
                src:
                  "https://media.flixel.com/cinemagraph/q0ltqf71unjk8mk8dnao?hd=true",
                allow: "autoplay"
              }
            })
          ]
        ),
        _c(
          "div",
          { staticClass: "carousel__item fluid__video carousel__item--thin" },
          [
            _c("iframe", {
              attrs: {
                src:
                  "https://media.flixel.com/cinemagraph/5u69pzstc7nr7dwwna4h?hd=true",
                allow: "autoplay"
              }
            })
          ]
        ),
        _c(
          "div",
          { staticClass: "carousel__item fluid__video carousel__item--wide" },
          [
            _c("iframe", {
              attrs: {
                src:
                  "https://media.flixel.com/cinemagraph/ken6qxdpc1td5lai1dgy?hd=true",
                allow: "autoplay"
              }
            })
          ]
        ),
        _c("div", { staticClass: "carousel--mobile" }, [
          _c("iframe", {
            attrs: {
              src:
                "https://media.flixel.com/cinemagraph/q0ltqf71unjk8mk8dnao?hd=true",
              allow: "autoplay"
            }
          })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "carousel__attributions" }, [
      _c("h2", [_vm._v("Check out more by the artists featured here.")]),
      _c("div", { staticClass: "attributions" }, [
        _c(
          "a",
          {
            attrs: { href: "https://flixel.com/jaiderrios/", target: "_blank" }
          },
          [_vm._v("jaiderrios")]
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://flixel.com/ThumbStopStudio/",
              target: "_blank"
            }
          },
          [_vm._v("ThumbStop.Studio")]
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://flixel.com/apricotberlin/",
              target: "_blank"
            }
          },
          [_vm._v("apricotberlin")]
        )
      ]),
      _c("div", { staticClass: "attributions--mobile" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://flixel.com/apricotberlin/",
              target: "_blank"
            }
          },
          [_vm._v("apricotberlin")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "influencerlp__ios" }, [
      _c("div", { staticClass: "product__section product__section--ios" }, [
        _c(
          "div",
          {
            staticClass: "product__section--container product__section--reverse"
          },
          [
            _c("div", { staticClass: "product__section--content" }, [
              _c("div", { staticClass: "productItem__title" }, [
                _c("h2", [_vm._v("Cinemagraphs are Easy to Create")])
              ]),
              _c("div", { staticClass: "productItem__desc" }, [
                _c("p", [
                  _vm._v(
                    "Traditional video requires more time, skills, and equipment. You only need a tripod, a camera or iPhone, and Cinemagraph Pro to easily create video content that stands out and captures attention. Whether you’re a travel blogger, lifestyle influencer, or foodie, you’ll be able to create cinemagraphs that uniquely express your story, and excite your audience."
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "product__section--image" }, [
              _c("img", {
                attrs: {
                  id: "iosImage",
                  srcset:
                    "https://cdn.flixel.com/static/static-web/products/ios/cinemagraph-pro-ios@2x.png" +
                    " 2x, " +
                    "https://cdn.flixel.com/static/static-web/products/ios/cinemagraph-pro-ios.png" +
                    " 1x"
                }
              })
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "influencerlp" }, [
      _c("div", { staticClass: "landingPage__section--cinemagraphFull" }, [
        _c("div", { staticClass: "influencerlp__container" }, [
          _c("h1", [
            _vm._v("Share Cinemagraphs On Blogs and Social Media and Stand Out")
          ]),
          _c("p", [
            _vm._v(
              "Share great content on the platforms that matter the most to you, while standing out. Cinemagraphs auto-play and auto-loop on Facebook, Instagram, Twitter, and Snapchat. You can also embed cinemagraphs on your blogs and websites in beautiful HD quality."
            )
          ])
        ]),
        _c("div", { staticClass: "fluid__video" }, [
          _c("iframe", {
            attrs: {
              src:
                "https://media.flixel.com/cinemagraph/e8vj14sr3faxv1ff2h40?hd=true",
              allow: "autoplay"
            }
          }),
          _c("div", { staticClass: "credit" }, [
            _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  href: "https://flixel.com/apricotberlin/"
                }
              },
              [_vm._v("apricotberlin")]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "influencerlp" }, [
      _c("div", { staticClass: "landingPage__section--container" }, [
        _c("div", { staticClass: "landingPage__section--content" }, [
          _c("h1", [_vm._v("Cinemagraphs Perform Better Than Still Photos")]),
          _c("p", [
            _vm._v(
              "Cinemagraphs cause audiences to pay attention to your content and engage with your storytelling more than still photos. They will be amazed by the hint of motion, and take action with a comment, like, share, or follow. Case studies show that cinemagraphs receive up to 51x higher engagement than still photos."
            )
          ])
        ]),
        _c("div", { staticClass: "landingPage__section--image" }, [
          _c("img", {
            attrs: {
              srcset:
                "https://cdn.flixel.com/static/static-web/influencerlp/pepsistats@2x.png" +
                " 2x, " +
                "https://cdn.flixel.com/static/static-web/influencerlp/pepsistats.png" +
                " 1x"
            }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "influencerlp" }, [
      _c("div", { staticClass: "landingPage__section--container" }, [
        _c("div", { staticClass: "landingPage__section--content" }, [
          _c("h1", [
            _vm._v("Join the Growing Community of Cinemagraph Creators")
          ]),
          _c("p", [
            _vm._v(
              "Visual storytellers and influencers around the world use cinemagraphs to share more mesmerizing stories on social media, blogs, and websites. Get inspired by 10 successful cinemagraph Instagrammers and start your cinemagraph journey today."
            )
          ]),
          _c(
            "a",
            {
              attrs: {
                href:
                  "http://blog.flixel.com/10-cinemagraph-instagrammers-you-should-be-following/"
              }
            },
            [_vm._v("Read more")]
          )
        ]),
        _c("div", { staticClass: "cinemagraph__section--image" }, [
          _c("div", { staticClass: "fluid__video influencer__cinemagraph" }, [
            _c("iframe", {
              attrs: {
                src:
                  "https://media.flixel.com/cinemagraph/ryziua2d056kb7est72v/",
                allow: "autoplay"
              }
            }),
            _c("div", { staticClass: "credit" }, [
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    href: "https://flixel.com/mattie/"
                  }
                },
                [_vm._v("mattie")]
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-169d126f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-169d126f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/landingPages/offers/500perks/500perks.vue
// module id = null
// module chunks = 